import TournamentWidget from '@components/widgets/tournament/tournament';
export default TournamentWidget;
